import { ManufacturerStockContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const ManufacturerStockPage = () => {
  return (
    <PageFrame>
      <ManufacturerStockContainer />
    </PageFrame>
  );
};
